
let enrollButtonForPoints;
let meetingId;
let serieId;


window.showMapOverlay = function (id) {
    var overlays = $('.overlayMap');
    overlays.each(function () {
        if ($(this).attr('data-id') == id) {
            $(this).attr('style', 'display:block!important; position: absolute; top: 0; width: ' + $('#meeting_map-' + id).width() + 'px');
        }
    });
}

// Initialize google maps on meeting details modal
window.inizializeGoogleMaps = function (id, address) {
    document.getElementById('meeting_modal_' + id).showModal();

    let mapElement = document.getElementById('meeting_map_' + id);
    var not_allowed = String(window.global_vars.env.DISABLE_EXTERNAL);

    if (address == "online") {
        let meetingLeftPart = document.getElementById('meeting-info-left-' + id);
        let meetingRightPart = document.getElementById('meeting-info-right-' + id);

        meetingLeftPart.classList.add('full-width');
        meetingRightPart.classList.add('hide');

        return;
    }

    if (mapElement == undefined || mapElement == null || address == "online") {
        return;
    }

    if (not_allowed != 'true') {
        var geocoder = new google.maps.Geocoder();
        var map = new google.maps.Map(document.getElementById('meeting_map_' + id), {
            zoom: 18,
            center: { lat: -34.397, lng: 150.644 }
        });

        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status === 'OK') {
                map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
                //mapElement.style.height = "100%";
                mapElement.style.minHeight = "240px";
            } else if (status === 'ZERO_RESULTS') {
                showMapOverlay(id);
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}


// Enroll to the meeting
window.enroll = function (id, seminarId, serieId = null, showMembershipModal, enrollWithMembership) {
    showProgressBar();

    if (showMembershipModal) {

        let membershipUrl = '/meeting/group_membership';

        if (window.location.href.includes("series")) {
            membershipUrl += '?page=series'
        } else if (window.location.href.includes("learning_box")) {
            membershipUrl += '?page=learning_box'
        }

        $.ajax({
            type: 'POST',
            url: membershipUrl,
            data: {
                'meeting_id': id,
                'serie_id': serieId,
            },
            success: function (data) {
                $('#GroupMembershipModal').text('');
                $('#GroupMembershipModal').append(data);
                $('#GroupMembershipModal').modal('show');
                $(".selectpicker").selectpicker('refresh');
            }
        });
        return;
    }

    let url = '/meeting/attend/' + id;

    if (serieId) {
        url = url + '/' + serieId;
    }

    if (window.location.href.includes("series")) {
        url += '?page=series'
    } else if (window.location.href.includes("learning_box")) {
        url += '?page=learning_box'
    }

    if (enrollWithMembership) {
        enrollWithMembership = $('select[name="membership_group_id"]').val();

        $('#GroupMembershipModal').modal('hide');
    }

    $('[data-meeting="' + id + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + id).show();

    $.ajax({
        type: 'POST',
        url: url,
        data: {
            membership: enrollWithMembership,
        },
        success: function (data) {

            $('#loader_meeting_' + id).hide();

            window.notification('success', data.message);
            $('[data-meeting="' + id + '"]').html(data.html);
            $('[data-meeting="' + id + '"]').animate({ opacity: 1 });
            $('#progress').width(data.progress + '%');

            if(serieId != null) {

                let mainObject = window.global_vars.unit_types.series
                if (window.location.href.includes("learning_box")) {
                    mainObject = window.global_vars.unit_types.learning_box
                }

                loadUnitDetails(serieId, mainObject, serieId, [seminarId, window.global_vars.unit_types.seminar]);
            }else{
                if(data.refreshEntireView){
                    location.reload();
                }
            }
        }
    });
}

// Confirm user deregistration
window.deregisterConfirm = function(id, seminar_id, serie_id) {
    const deregisterModal = document.getElementById('deregisterParticipantModal');
    deregisterModal.showModal();

    deregisterModal.dataset.meeting_id = id;
    deregisterModal.dataset.seminar_id = seminar_id;
    if(serie_id){
        deregisterModal.dataset.serie_id = serie_id;
    }

    let reason = $('#deregistration_reason').val();
    let confirmButton = $('#confirm_button');

    if(!reason) {
        confirmButton.prop("disabled", true);
        confirmButton.prop('title', window.trans.lms.DeregistrationReasonRequired)
    }

}

// Remove enrollment
window.cancelMeeting = function () {

    const deregisterModal = document.getElementById('deregisterParticipantModal');
    const meetingId       = deregisterModal.dataset.meeting_id;
    const seminarId       = deregisterModal.dataset.seminar_id;
    const serieId         = deregisterModal.dataset.serie_id;
    
    let url = '/meeting/cancel/' + meetingId;
    let deregistrationReason = $( "#deregistration_reason option:selected" ).val();

    if (serieId) {
        url = url + '/' + serieId;
    }

    if (window.location.href.includes("series")) {
        url += '?page=series'
    } else if (window.location.href.includes("learning_box")) {
        url += '?page=learning_box'
    }

    $('[data-meeting="' + meetingId + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + meetingId).show();

    const meetingDiv = $('[data-meeting="' +  meetingId + '"]');

    meetingDiv.animate({ opacity: 0.5 });
    $('#loader_meeting_' +  meetingId).show();

    showProgressBar();

    $.ajax({
        type: 'POST',
        url: url,
        data: {
            'reason' : deregistrationReason
        },
        success: function (data) {
            deregisterModal.close();
            setTimeout(() => window.notification('success', data.message), 0);

            $('#loader_meeting_' + meetingId).hide();
            meetingDiv.html(data.html);
            meetingDiv.animate({ opacity: 1 });
            
            if(data.html === "") {
                meetingDiv.remove();

                location.href = data.redirect_to_homepage ? '/' : location.href;
            }

            $('#progress').width(data.progress + '%');

            if(serieId) {

                let mainObject = window.global_vars.unit_types.series
                if (window.location.href.includes("learning_box")) {
                    mainObject = window.global_vars.unit_types.learning_box
                }

                loadUnitDetails(serieId, mainObject, serieId, [seminarId, window.global_vars.unit_types.seminar]);
            }else{
                if(data.refreshEntireView){
                    location.reload();
                }
            }
        }
    });
}


// Request access to meeting
window.requestMeeting = function (id) {
    $('[data-meeting="' + id + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + id).show();

    let button = isPrioritizationPointsActivated ? enrollButtonForPoints : event.currentTarget

    let points = isPrioritizationPointsActivated ? $('#user_interest').val() : 0;

    showProgressBar()

    $.ajax({
        type: 'POST',
        url: '/request_meeting/' + id,
        data: {
            'points': points
        },
        success: function (data) {
            // button.removeAttribute('onclick')
            // button.textContent = window.trans.lms.Requested

            if (isPrioritizationPointsActivated) $('#UserInterestModal').modal('hide');
            // window.notification('success', data.message);

            // Refreshing only this meeting block !important
            location.reload();
            
            $('#loader_meeting_' + id).hide();
            window.notification('success', data.message);
            $('[data-meeting="' + id + '"]').html(data.html);
            $('[data-meeting="' + id + '"]').animate({ opacity: 1 });
        }
    });
}


// Request for meeting in planing status
window.requestMeetingPlanning = function (id) {
    // $('[data-meeting="'+id+'"]').animate({opacity:0.5});
    // $('#loader_meeting_'+id).show();

    let button = event.currentTarget;

    showProgressBar()

    $.ajax({
        type: 'POST',
        url: '/request_meeting_planning/' + id,
        success: function (data) {
            button.removeAttribute('onclick');
            button.textContent = window.trans.lms.ParticipationRequested;

            window.notification('success', response.message);
            location.reload();

            // $('#loader_meeting_'+id).hide();
            // window.notification('success', data.message);
            // $('[data-meeting="'+id+'"]').html(data.html);
            // $('[data-meeting="'+id+'"]').animate({opacity:1});
        },
        error: function (error) {
            window.notification('danger', error.responseJSON.message);
        }
    });
}

// Add to waitlist
window.enrollOnWaitlist = function (meetingId) {
    $('[data-meeting="' + meetingId + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + meetingId).show();

    let button = event.currentTarget;

    showProgressBar();

    $.ajax({
        type: 'POST',
        url: '/add/meeting_waitlist/' + meetingId,
        success: function (response) {
            $('#loader_meeting_' + meetingId).hide();
            window.notification('success', response.message);
            $('[data-meeting="' + meetingId + '"]').html(response.html);
            $('[data-meeting="' + meetingId + '"]').animate({ opacity: 1 });
            $('#progress').width(response.progress + '%');
        },
        error: function (error) {
            window.notification('danger', error.responseJSON.message);
        }
    });
}

// Remove from waitlist
window.removeFromWaitlist = function (meetingId) {
    $('[data-meeting="' + meetingId + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + meetingId).show();

    let button = event.currentTarget;

    showProgressBar();

    $.ajax({
        type: 'POST',
        url: '/remove/meeting_waitlist/' + meetingId,
        success: function (response) {
            $('#loader_meeting_' + meetingId).hide();
            window.notification('success', response.message);
            $('[data-meeting="' + meetingId + '"]').html(response.html);
            $('[data-meeting="' + meetingId + '"]').animate({ opacity: 1 });
            $('#progress').width(response.progress + '%');
        },
        error: function (error) {
            window.notification('danger', error.responseJSON.message);
        }
    });
}

// Modal to enter user interest for meeting
window.userInterestAction = function (id) {

    enrollButtonForPoints = event.currentTarget;

    let isRequestApproved = false;

    if (permissionSession) {
        $.ajax({
            type: 'GET',
            url: '/request_meeting/check/approved',
            data: {
                'meeting_id': id,
            },
            success: function (response) {
                isRequestApproved = response;
            }
        });
    }

    $.ajax({
        type: 'POST',
        url: '/meeting/user/prioritization/points',
        data: {
            'meeting_id': id,
        },
        success: function (data) {
            userInterestOption(data);
            extraUserPoints(id);
            $('#UserInterestModal').modal('show');

            if (permissionSession && !isRequestApproved) {
                $('#confirm-button').attr('onclick', 'requestMeeting(' + id + ')')
                $('#confirm-button').html(window.trans.lms.Request)
            } else {
                $('#confirm-button').attr('onclick', 'enrollOnRanklist(' + id + ')')
            }
        }
    });
}

// Add remaining points into dropdown - modal about user interest
window.userInterestOption = function (options) {
    let pointsDropdown = $('#user_interest');

    pointsDropdown.empty();
    options.forEach(element => {
        var option = new Option(element, element)
        pointsDropdown.append(option);
    });
}

// Get user's extra prioritization points from previous scoring period (points from cancelled meeting by status) 
window.extraUserPoints = function (meetingId) {

    $.ajax({
        type: 'GET',
        url: '/meeting/user/extra/prioritization/points',
        data: {
            'meeting_id': meetingId,
        },
        success: function (response) {
            if (response.hasExtraPoints) {
                $('#extra-points-field').css('display', 'inline');
                $('#user_extra_points').html('');
                $('#user_extra_points').html(' (+' + response.extraPoints + ')');
            }
        }
    });
}

// Add user to ranklist
window.enrollOnRanklist = function (meetingId) {

    let button = enrollButtonForPoints;
    let points = $('#user_interest').val();
    let extra_points = $('#extra_points').val() != null ? $('#extra_points').val() : 0;

    showProgressBar();

    $('[data-meeting="' + meetingId + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + meetingId).show();

    $.ajax({
        type: 'POST',
        url: '/add/meeting_ranklist/' + meetingId,
        data: {
            'points': points,
            'extra_points': extra_points,
            'origin': 'user'
        },
        success: function (data) {

            $('#UserInterestModal').modal('hide');

            button.removeAttribute('onclick')
            button.setAttribute('onclick', 'removeFromRanklist(' + meetingId + ')')
            button.textContent = window.trans.lms.logout

            $('#loader_meeting_' + meetingId).hide();

            window.notification('success', data.message);
            $('[data-meeting="' + meetingId + '"]').html(data.html);
            $('[data-meeting="' + meetingId + '"]').animate({ opacity: 1 });
            $('#progress').width(data.progress + '%');

            loadUnitDetails(meetingId, window.global_vars.unit_types.meeting, null);
        },
        error: function (error) {
            window.notification('danger', error.responseJSON.message);
        }
    });
}


// Remove user from ranklist
window.removeFromRanklist = function (meetingId) {

    let button = event.currentTarget

    showProgressBar()

    $('[data-meeting="' + meetingId + '"]').animate({ opacity: 0.5 });
    $('#loader_meeting_' + meetingId).show();

    $.ajax({
        type: 'POST',
        url: '/remove/meeting_ranklist/' + meetingId,
        success: function (data) {

            button.removeAttribute('onclick')
            button.setAttribute('onclick', 'userInterestAction(' + meetingId + ')')
            button.textContent = window.trans.lms.apply

            $('#loader_meeting_' + meetingId).hide();

            window.notification('success', data.message);
            $('[data-meeting="' + meetingId + '"]').html(data.html);
            $('[data-meeting="' + meetingId + '"]').animate({ opacity: 1 });
            $('#progress').width(data.progress + '%');

            loadUnitDetails(meetingId, window.global_vars.unit_types.meeting, null);
        },
        error: function (error) {
            window.notification('danger', error.responseJSON.message);
        }
    });

}


// Open/close meetings section
window.expandMeetingsSection = function (seminar_id, serie_id, forceReload) {

    let requestData = new Object();

    requestData.id = seminar_id;

    if(serie_id === undefined){
        serie_id=null;
    }else{
        requestData.collection_id = serie_id;
    }

    if(forceReload === undefined){
        forceReload=false;
    }

    let meetingSection = document.getElementById('meetings-container_' + seminar_id);
    let section = $('#meetings-container_' + seminar_id);

    $('.unit-details').animate({ opacity: 0.5 });
    $('#loader_seminar_' + seminar_id).show();

    if (window.location.href.includes("series")) {
        requestData.page = 'series';
    } else if (window.location.href.includes("learning_box")) {
        requestData.page = 'learning_box';
    }

    const cart_items = localStorage.getItem('cart_items');
    if(cart_items) {
        requestData.cart_items = cart_items;
    }
   
    // If content wasn't previously loaded then send the request for content, if yes then just open it
    if (!section.children().length || forceReload) {
        $.ajax({
            type: 'GET',
            url: '/meeting',
            data: requestData,
            success: function (response) {
                section.text('');
                section.append(response);

                // Force reload all seminar meetings
                if (!forceReload) {
                    meetingSection.classList.remove('not-expanded');
                    sessionStorage.setItem('meetings-expanded', 'true');
                }

                if(localStorage.getItem('redirected_from_calendar_meeting_id')) {
                    $('#single_meeting_wrapper_' + localStorage.getItem('redirected_from_calendar_meeting_id') + ' a').trigger('click');  
                    localStorage.removeItem('redirected_from_calendar_meeting_id');
                }

                section.get(0).scrollIntoView({behavior: 'smooth', block: 'center', inline: 'start'});
            },
            error: function (error) {
                // alert(error);
                throw new Error(error);
            }
        });
    } else {
        if (meetingSection.classList.contains('not-expanded')) {
            meetingSection.classList.remove('not-expanded');
            sessionStorage.setItem('meetings-expanded', 'true');
            section.get(0).scrollIntoView({behavior: 'smooth', block: 'center', inline: 'start'});
        } else {
            meetingSection.classList.add('not-expanded');
            sessionStorage.removeItem('meetings-expanded');
        }
    }
    $('#loader_seminar_'+seminar_id).hide();
    $('.unit-details').animate({opacity:1});
    
    event.preventDefault();
}

// Expand meetings section on load
window.expandOnLoad = function () {
    if (sessionStorage.getItem('meetings-expanded') && sessionStorage.getItem('meetings-expanded') == 'true') {
        let meetingSection = document.getElementById('meetings-container_' + seminarId);
        if (meetingSection.classList.contains('not-expanded')) {
            meetingSection.classList.remove('not-expanded');
            sessionStorage.removeItem('meetings-expanded');
        }
    }
}

window.changeArrowDirection = function (arrow) {
    if (Array.from(arrow.classList).includes('down')) {
        arrow.src = '/images/arrowup.png';
        arrow.classList.add('up');
        arrow.classList.remove('down');
    } else {
        arrow.src = '/images/arrowdown.png';
        arrow.classList.add('down');
        arrow.classList.remove('up');
    }
}

expandOnLoad();



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/meetings.js